<template>
    <div class="problemsList">
       <div class="question">
           <span class="Q_title">Q{{question_tit_index}}:</span><p>{{problemsContent.title}}</p>
           <span class="direction" @click="direction(num)" :class="{moveDown:isActive,moveUp:hasError}" ><img src="../../assets/images/service/direction.png" alt=""></span>
       </div>

       <transition name="slide-fade">
           <div class="answer" v-if="isShow">
               <span class="Q_title">A{{question_tit_index}}:</span>
               <p v-html="htmlDecode(problemsContent.content)"></p>
           </div>
       </transition>

    </div>
</template>
<script>
export default {
  name: "problemsList",
  props: ["problemsContent", "problemsIndex"],
  data: function() {
    return {
      num: 0,
      isActive: false,
      hasError: false,
      isShow: false,
      question_tit_index: ""
    };
  },
  created: function() {
    this.problemsListIndex = parseInt(this.problemsIndex) + parseInt("1");
    if (this.problemsListIndex < "10") {
      this.question_tit_index = "00" + this.problemsListIndex;
    } else if ("10" <= this.problemsListIndex < "100") {
      this.question_tit_index = "0" + this.problemsListIndex;
    }
  },
  methods: {
    direction: function(n) {
      n++;
      this.num = n;
      if (n % 2 == "1") {
        this.isActive = true;
        this.hasError = false;
        this.isShow = true;
      } else {
        this.isActive = false;
        this.hasError = true;
        this.isShow = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";
@import "../../assets/less/direction";
.problemsList {
  width: @width - 6;
  margin: 30px auto;

  span.Q_title {
    float: left;
  }
  p {
    display: inline-block;
  }
  .question {
    line-height: 22px;
    .border-bottom;
    padding-bottom: 7px;
    p {
      width: 82%;
    }
    span.direction {
      float: right;
      width: 9px;
      margin: 3px 4px 0 0;
      animation-duration: 500ms;
      animation-fill-mode: forwards;
      img {
        .img;
      }
    }
  }
  .answer {
    background: hsl(228, 8%, 93%, 0.67);
    .border-bottom;
    width: @width;
    .box-sizing;
    padding: 10px;
    span,
    p {
      font-size: 0.8rem;
      line-height: 20px;
    }
    p {
      width: 89%;
    }
  }
}
/*    .moveDown {
        animation-name:moveDown;
        animation-duration:500ms;
        animation-fill-mode:forwards;
    }
    .moveUp {
        animation-name:moveUp;
        animation-duration:500ms;
        animation-fill-mode:forwards;
    }
    @keyframes moveDown {
        from{

            transform: rotate(0deg);
        }
        to{

            transform: rotate(90deg);
        }
    }
    @keyframes moveUp{
        from{

            transform: rotate(90deg);
        }
        to{
            transform: rotate(0deg);
        }
    }
    .slide-fade-enter-active {
        transition: all .8s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
    }*/
</style>
